
        import Symbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-rescls-file_bucket",
  "use": "icon-rescls-file_bucket-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-rescls-file_bucket\"><path fill=\"#106a90\" d=\"M2.863 3a.844.844 0 0 0-.832.857L2 8.143h20V5.57a.845.845 0 0 0-.832-.857H9.369a.82.82 0 0 1-.68-.363v-.002l-.668-.983A.83.83 0 0 0 7.34 3zM2 9.428v10.715a.845.845 0 0 0 .834.857H5.75a.634.634 0 0 1-.625-.642v-.643a.634.634 0 0 1 .625-.645h1.875A.633.633 0 0 1 7 18.43v-.645a.634.634 0 0 1 .625-.642H5.75a.634.634 0 0 1-.625-.643v-.642a.634.634 0 0 1 .625-.643h1.875A.636.636 0 0 1 7 14.57v-.64a.634.634 0 0 1 .625-.645H5.75a.634.634 0 0 1-.625-.642V12a.634.634 0 0 1 .625-.642h2.5c.35.004.63.292.625.642v.643a.634.634 0 0 1-.625.642h1.875c.35.005.63.294.625.645v.64a.634.634 0 0 1-.625.645H8.25c.35.005.63.293.625.643v.642a.634.634 0 0 1-.625.643h1.875c.35.005.63.292.625.642v.645a.634.634 0 0 1-.625.64H8.25c.35.005.63.294.625.645v.643A.634.634 0 0 1 8.25 21h12.916a.845.845 0 0 0 .834-.857V9.428z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-rescls-file_bucket"/>
                </svg>
            );
        };

        Icon.id = "icon-rescls-file_bucket";

        export default Icon;
    